<template>
  <div class="container">
    <div class="profile-page-title row justify-content-center">
      <div class="col-lg-auto col-12">
        <router-link :to="{ name: 'profile.medals' }">{{ $t('my_achievements') }}</router-link>
      </div>
      <div class="col-lg-auto col-12">
        <span>{{ $t('tests_results') }}</span>
      </div>
      <div class="col-lg-auto col-12">
        <router-link :to="{ name: 'profile.map' }">{{ $t('map') }}</router-link>
      </div>
    </div>
    <div v-if="results.length > 0">
      <ExamCard
          :key="result.id"
          :result="result"
          v-for="result in results"
      />
    </div>

    <div
        class="text-center pt-5 pb-8"
        v-else
    >
      <p class="h2">{{ $t('exams_results_empty') }}</p>
      <router-link
          v-if="flavorConfig.showLinkToExamsAtEndOfCourse"
          class="btn btn-default"
          :to="{ name: 'exams' }"
      >
        {{ $t('pass_exam') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import userApi from '@/data/UserApi';
import ExamCard from './ExamCard';

export default {
  name: 'Browse',

  data() {
    return {
      user: {
        //userCourses: []
      },
      results: [],
      loading: true,
      loadingUser: true,
      loadingExam: true,
    }
  },

  mounted() {
    this.fetchProfile()
    this.fetchExams()
  },

  methods: {
    fetchProfile() {
      userApi.fetchProfile()
          .then(response => {
            this.user = response;
            this.loadingUser = false
            this.loading = this.loadingUser || this.loadingExam
          });
    },

    fetchExams() {
      userApi.fetchExams()
          .then(response => {
            this.results = response;
            this.loadingExam = false
            this.loading = this.loadingUser || this.loadingExam
          });
    }
  },

  components: {
    ExamCard,
  }
}
</script>

<style>
.profile-page-title__count {
  color: #c0c0c0;
  font-size: 1rem;
}

.profile-page-title a, .profile-page-title a:hover {
  color: #0493c3;
  border-bottom: 1px solid;
}

/* cards */
.course-card {
  border: 1px solid #d7e0e5;
  border-radius: 6px;
  margin-bottom: 30px;
  padding: 20px;
  position: relative;
}

.course-card-title {
  display: block;
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  line-height: 1.4;
}

.course-card-title__language {
  color: #c0c0c0;
}

.course-card__button {
  border-radius: 18px;
  color: #fff !important;
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
}

.course-card__button--red {
  background-color: #f15a21;
}

.course-card__description,
.course-card__description p {
  color: #999 !important;
  line-height: normal;
}
</style>
